import React ,{ useEffect, useRef, useState } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { IFilterSocieteBO, getDefaultFilterSociete } from "../../../models/interfaces/IFilterSocieteBO";
import { TypeCompteSociete, validationMode } from "../../../config/helpers";
import CpntMultiSelect from "../../../components/CpntMultiSelect";
import DatePickerInput from "../../../components/forms/DatePickerInput";
import { MESSAGE_PLACEHOLDER_CHOIX_DATE } from "../../../data/message-placeholders";
import CpntFilterButtons from "../../../components/CpntFilterButtons";

interface IProps {
  filter?: IFilterSocieteBO;
  changeFilter: (data: IFilterSocieteBO) => void;
}


//Arrive pas a faire passer unb param au parent...
const SocietesFilter: React.FC<IProps> = ({ filter, changeFilter }) => {

  const prevFilterRef = useRef<IFilterSocieteBO | undefined>(filter);
  const [IdsTypeCompteSociete, setIdsTypeCompteSociete] = useState<any[]>([]);

  useEffect(() => {

    // if (getValues("Message") !== filter?.Message) {
    //   setValue("Message",filter?.Message);
    // }

    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }

    prevFilterRef.current = filter;
  }, [filter]);

  
  const formMethods = useForm<IFilterSocieteBO>({
    defaultValues: getDefaultFilterSociete(),
  });

  const { handleSubmit, reset, getValues,watch } = formMethods;
  const watchDates = watch(["DateDebut", "DateFin"]);

  const handleResetForm = () => {
    localStorage.removeItem("IFilterSocietesBO");
    setIdsTypeCompteSociete([]);
    changeFilter(getDefaultFilterSociete());
    reset(getDefaultFilterSociete()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };


  const onSubmit = (data: IFilterSocieteBO) => {
        const IdsTypeCompteSocieteSelected = IdsTypeCompteSociete.map((option: { value: any }) => option.value);
        const combinedData: IFilterSocieteBO = {
          ...data,
          IdsTypeCompteSociete: IdsTypeCompteSocieteSelected,
        };

    changeFilter(combinedData);
    localStorage.setItem("IFilterSocietesBO",JSON.stringify(combinedData)); //needed ??
  };


  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      //e.preventDefault();
      handleSubmit(onSubmit)();
      //SubmitButton.current.click();
    }
  };
  useEffect(() => {
        if (filter?.IdsTypeCompteSociete) {
          const SelectedTypeCompteSocieteValues = TypeCompteSociete?.filter((CompteSociete: { Id: any }) =>
            filter?.IdsTypeCompteSociete?.includes(CompteSociete.Id)
          ) || [];
          const SelectedTypeCompteSocieteValuesList = SelectedTypeCompteSocieteValues?.map((CompteSociete) => {
            return {
              label: CompteSociete.Libelle,
              value: CompteSociete.Id,
            };
          });
          setIdsTypeCompteSociete(SelectedTypeCompteSocieteValuesList);
        }
      }, [TypeCompteSociete]);

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6,6,6,6,6, 12]}>
            <TextInput
              label="Raison sociale"
              formName="RaisonSociale"
              validationStyle={validationMode.none}
              placeholder="Raison sociale"
            />
             <TextInput
              label="Id Societe"
              formName="IdSociete"
              validationStyle={validationMode.none}
              placeholder="Id Societe"
            />
            <DatePickerInput
              label="Création après le"
              formName="DateDebut"
              maxDate={watchDates[1] ? watchDates[1] : new Date()}
              validationStyle={validationMode.none}
              placeholder={MESSAGE_PLACEHOLDER_CHOIX_DATE}
            />
            <DatePickerInput
              label="Création avant le"
              formName="DateFin"
              minDate={watchDates[0]}
              maxDate={new Date()}
              validationStyle={validationMode.none}
              placeholder={MESSAGE_PLACEHOLDER_CHOIX_DATE}
            />
            
              <CpntMultiSelect 
            DefaultLibelle="Sélectionner..."
            options={TypeCompteSociete}
            value={IdsTypeCompteSociete}
            setSelected={setIdsTypeCompteSociete}
            label="Sélectionner un type de compte"
            ></CpntMultiSelect>
             <TextInput
              label="Siren"
              formName="Siren"
              validationStyle={validationMode.none}
              placeholder="Siren"
            />
              <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default SocietesFilter;
